/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getId } from '@fluentui/utilities';
import { action, observable } from 'mobx';
import { OmitFunctions } from 'src/core/stores/types';
import { QnaMakerSourceContentStructureKind, QnaMakerSourceType } from 'src/qnaMaker/core/services/sources/qnaMakerSourcesSwaggers';

export class QnaMakerSourceStore {
    public readonly id: string;

    public readonly source: string;

    public readonly url: string;

    public readonly kind: QnaMakerSourceType;

    public readonly contentStructureKind: QnaMakerSourceContentStructureKind;

    public readonly lastUpdatedDateTime: Date;

    @observable public name: string;

    constructor(data: Partial<OmitFunctions<QnaMakerSourceStore>>) {
        this.id = data.id ?? getId(data.name);
        this.url = data.url;
        this.name = data.name;
        this.kind = data.kind;
        this.source = data.source;
        this.lastUpdatedDateTime = data.lastUpdatedDateTime;
        this.contentStructureKind = data.contentStructureKind;
    }

    @action
    public renameSource(newName: string) {
        this.name = newName;
    }
}
